export default function Footer() {
  const year = 2026;
  return (
    <footer className="border-t border-background-300 bg-background-200">
      <div className="mx-auto w-full max-w-[1440px] px-4 md:px-6 pt-12 md:pt-14 pb-8">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-[1.4fr_1fr_1fr_1fr] lg:grid-cols-[1.6fr_1fr_1fr_1fr_1fr]">
          <div className="col-span-2 md:col-span-2 lg:col-span-1">
            <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50 font-heading text-lg font-black">
                雷
              </span>
              <span className="font-heading text-xl font-black text-foreground-950">51大雷</span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              专注记录全网名场面、翻车瞬间与翻车合集。每一段被回放的十秒，都是当代影像档案的一部分。
            </p>
            <div className="mt-4 flex items-center gap-3">
              <a href="#top" aria-label="新浪微博" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600 hover:text-primary-600">
                <i className="ri-weibo-line text-base" />
              </a>
              <a href="#top" aria-label="视频号" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600 hover:text-primary-600">
                <i className="ri-video-line text-base" />
              </a>
              <a href="#top" aria-label="抖音" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600 hover:text-primary-600">
                <i className="ri-music-2-line text-base" />
              </a>
              <a href="#top" aria-label="B站" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600 hover:text-primary-600">
                <i className="ri-clapperboard-line text-base" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">浏览现场</h4>
            <ul className="mt-3 flex flex-col gap-2.5 text-sm text-foreground-600">
              <li><a href="#scene" className="hover:text-primary-600">翻车现场实录</a></li>
              <li><a href="#moments" className="hover:text-primary-600">名场面大赏</a></li>
              <li><a href="#rank" className="hover:text-primary-600">本周热度榜</a></li>
              <li><a href="#archive" className="hover:text-primary-600">实录档案</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">栏目分区</h4>
            <ul className="mt-3 flex flex-col gap-2.5 text-sm text-foreground-600">
              <li><a href="#topics" className="hover:text-primary-600">直播翻车实录</a></li>
              <li><a href="#topics" className="hover:text-primary-600">舞台名场面</a></li>
              <li><a href="#topics" className="hover:text-primary-600">街头实录馆</a></li>
              <li><a href="#topics" className="hover:text-primary-600">首发事故清单</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">关于本站</h4>
            <ul className="mt-3 flex flex-col gap-2.5 text-sm text-foreground-600">
              <li><a href="#top" className="hover:text-primary-600">51大雷简介</a></li>
              <li><a href="#join" className="hover:text-primary-600">投稿与线索</a></li>
              <li><a href="#top" className="hover:text-primary-600">内容规范</a></li>
              <li><a href="#top" className="hover:text-primary-600">联系方式</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">刷新入口</h4>
            <ul className="mt-3 flex flex-col gap-2.5 text-sm text-foreground-600">
              <li><a href="#rank" className="hover:text-primary-600">今日更新榜</a></li>
              <li><a href="#moments" className="hover:text-primary-600">全网名场面</a></li>
              <li><a href="#archive" className="hover:text-primary-600">翻车记录大全</a></li>
              <li><a href="#top" className="hover:text-primary-600">回到头版</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 border-t border-background-300 pt-6 text-xs text-foreground-500">
          <p className="whitespace-nowrap">© {year} 51大雷 · 翻车现场馆。页面为静态演示，仅供浏览。</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <a href="#top" className="hover:text-primary-600 whitespace-nowrap">翻车现场</a>
            <a href="#top" className="hover:text-primary-600 whitespace-nowrap">翻车合集</a>
            <a href="#top" className="hover:text-primary-600 whitespace-nowrap">名场面</a>
            <a href="#top" className="hover:text-primary-600 whitespace-nowrap">翻车瞬间</a>
          </p>
        </div>
      </div>
    </footer>
  );
}